export const VERSION = '4.71.1'; // x-release-please-version
//# sourceMappingURL=version.mjs.map